import { Dispatch } from 'redux';

import AIEmailTemplatesController from '../controllers/AiEmailTemplatesController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class AIEmailTemplateCRUDActions extends CrudActionContainer {
  resetAction: string;
  toggleProcessingAction: string;
  cancelAction: string;

  constructor() {
    super('AI_EMAIL_TEMPLATE');
    this.resetAction = super.makeActionKey('RESET');
    this.toggleProcessingAction = super.makeActionKey('TOGGLE_PROCESSING');
    this.cancelAction = super.makeActionKey('CANCEL');
  }

  toggleProcessing(value = true) {
    return {
      type: this.toggleProcessingAction,
      payload: { value },
    };
  }

  cancel(error: string | null = null) {
    return {
      type: this.cancelAction,
      payload: { error },
    };
  }

  retrieve(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));
      let response;
      try {
        response = await AIEmailTemplatesController.getOne(facebookPageId);
      } catch (error) {
        dispatch(this.cancel('Error retrieving AI email template'));
        return commonHandler(dispatch)(error);
      }
      dispatch(this.retrieved(response));

      return response;
    };
  }

  reset() {
    return {
      type: this.resetAction,
    };
  }
}

const aiEmailTemplateCRUDActions = new AIEmailTemplateCRUDActions();
export default aiEmailTemplateCRUDActions;

export const useAIEmailTemplateCRUDActions = getActionHookBuilder(
  aiEmailTemplateCRUDActions,
  ['retrieve', 'toggleProcessing', 'cancel', 'reset'],
);
